module.exports = __webpack_public_path__ + "assets/img/chartCard-bg-light.07e096df.svg";